import { ContractsRequestInterface } from '../../../../interfaces/request/contracts/contracts-request/contracts-request-interface';

export class ContractsRequestModel implements ContractsRequestInterface {
  ClientId: string = '';
  PolicyNumber: string = '';
  PolicyStartDateEnd: string = '';
  PolicyStartDateStart: string = '';
  PolicyState: string = '';
  page: number | undefined;
  pageSize: number | undefined;

  constructor(init?: Partial<ContractsRequestModel>) {
    Object.assign(this, init);
  }
}
